import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import { logout } from '../actions/users'
import CircularProgress from '@material-ui/core/CircularProgress'
import { bindActionCreators } from 'redux'
import i18n from '../i18n'

class Logout extends Component {
  state = {
    isLoggedOut: false
  }

  constructor (props) {
    super(props)
    this.props.logout()
  }

  render () {
    if (!(this.props.self && this.props.self.user)) {
      return <Redirect to='/login' />
    }

    return (
      <div id='logout' className='text-center'>
        <h3>{i18n.logoutPage.loading}</h3>
        <CircularProgress />
      </div>
    )
  }
}

// state = application state
function mapStateToProps (state) {
  // Whatever is returned will show up as props inside props of this component
  return {
    self: state.self
  }
}

// Anything retured from this function will end up as props on the Login container
function mapDispatchToProps (dispatch) {
  // whenever authenticateUser is called, the result should be passed to all the the reducers
  return bindActionCreators({
    logout
  }, dispatch)
}

// Promote Login from a component to a container - it needs to know about this new dispatch method.
export default connect(mapStateToProps, mapDispatchToProps)(Logout)
